async function registrarUsuarioWeb(ApiuserRegistry, ipEquipo){

    var axios = require("axios");


    var fingerprint = await getCookie("user_alg");

    if (fingerprint != "")
    {
        if (ApiuserRegistry != "" && ipEquipo != "")
        {
    
            try {     
                
    
                if (navigator.userAgentData.mobile == true)
                {

                    var tipo = "mobile";

                } else {

                    var tipo = "desktop";


                }


                navegador = window.navigator;

                var navegador = {};
                for (var i in navigator) navegador[i] = navigator[i];

                var datosMandar = {
                    "tipo" : tipo,
                    "ip" : ipEquipo,
                    "userAgent" : navigator.userAgent,
                    "width" : window.innerWidth,
                    "height" : window.innerHeight,
                    "platform" : navigator.platform,
                    "navigator" : (navegador),
                    "fingerprint" : fingerprint
                };
        
                let Datos = await axios(
                    {
                        method: 'post',
                        url: ApiuserRegistry,
                        data: datosMandar,
                        config: { headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json' 
                            }}
                    }
                );
        
                return Datos.data;
                
            } catch (error) {
        
                let retorno = {"status" : "KO", "message" : error};
                return retorno;
                
            }
    
    
        } else {
    
    
            let retorno = {"status" : "KO", "message" : "No existe la variable ApiuserRegistry"};
            return retorno;
    
    
        }

    } else {

    
        let retorno = {"status" : "KO", "message" : "No existe el fingerprint"};
        return retorno;


    }

    
 

}


async function getCookie(id) {

    let value = document.cookie.match('(^|;)?' + id + '=([^;]*)(;|$)');
    return value ? unescape(value[2]) : null;
 
 }


exports.registrarUsuarioWeb = registrarUsuarioWeb;
